import { create } from 'zustand'
import { biApi } from '@/lib/api'

export interface NotificationItem {
  id: number
  type: string
  title: string
  body: string
  eventData: {
    days?: number
    startDate?: string
    endDate?: string
    rowsAffected?: number
    error?: string | null
    triggeredBy?: string
  } | null
  createdAt: string
  read: boolean
}

interface NotificationsState {
  unreadCount: number
  items: NotificationItem[]
  lastSuccess: { id: number; title: string; createdAt: string } | null
  lastFailure: { id: number; title: string; createdAt: string } | null
  loaded: boolean
  load: () => Promise<void>
  markRead: (id: number) => Promise<void>
  markAllRead: () => Promise<void>
}

export const useNotificationsStore = create<NotificationsState>()((set) => ({
  unreadCount: 0,
  items: [],
  lastSuccess: null,
  lastFailure: null,
  loaded: false,

  load: async () => {
    try {
      const response = await biApi.getNotifications()
      if (response.data.success) {
        const d = response.data.data
        set({
          unreadCount: d.unreadCount,
          items: d.items,
          lastSuccess: d.lastSuccess,
          lastFailure: d.lastFailure,
          loaded: true,
        })
      }
    } catch (err) {
      console.error('Error loading notifications:', err)
    }
  },

  markRead: async (id: number) => {
    try {
      await biApi.markNotificationRead(id)
      set((state) => ({
        unreadCount: Math.max(0, state.unreadCount - (state.items.find(i => i.id === id && !i.read) ? 1 : 0)),
        items: state.items.map(i => (i.id === id ? { ...i, read: true } : i)),
      }))
    } catch (err) {
      console.error('Error marking notification as read:', err)
    }
  },

  markAllRead: async () => {
    try {
      await biApi.markAllNotificationsRead()
      set((state) => ({
        unreadCount: 0,
        items: state.items.map(i => ({ ...i, read: true })),
      }))
    } catch (err) {
      console.error('Error marking all notifications as read:', err)
    }
  },
}))
